import React from 'react';
import { t } from '../i18n';
/**
 * For information about how and when to use this component,
 * [refer to its full documentation page](https://design.cms.gov/components/skip-nav/).
 */
export var SkipNav = function SkipNav(_ref) {
  var children = _ref.children,
    href = _ref.href,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("a", {
    className: "ds-c-skip-nav",
    href: href,
    onClick: onClick
  }, children !== null && children !== void 0 ? children : t('skipNav.default'));
};
export default SkipNav;